<template lang="pug">
  .select-technician
    div
      //- BOTON ENTREGAR A TECNICO PARA DIAGNOSTICO
      //- Da salida de bodega a un equipo asignado a un técnico para que lo diagnostique
      button.change-button(
        :disabled="disabled || loading"
        title="Entregar a técnico para diagnostico"
        data-testid="action-btn-entregar-tecnico"
        @click="entregarATecnico()")
        b-spinner(v-if="loading" small)
        span {{ loading ? 'Procesando...' : 'Entregar a técnico para diagnostico' }}
</template>

<script>
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'
import LoadingButtonMixin from '@/mixins/LoadingButtonMixin'

export default {
  name: 'ActionEntregarTecnico',
  mixins: [LoadingButtonMixin],
  props: ['ot', 'disabled'],

  data() {
    return {
      state: false,
      usuarios: [],
    }
  },
  methods: {
    ...mapActions('OTStore', ['entregarEquipoTecnico']),
    async entregarATecnico() {
      try {
        await this.executeWithLoading(async () => {
          const resp = await this.entregarEquipoTecnico({
            otId: this.ot.ot,
            technitianId: this.ot.tecnico_asignado.id,
          })
          if (resp.status === 200) {
            this.$bvToast.toast(
              `OT entregada a ${this.ot.tecnico_asignado.first_name} ${
                this.ot.tecnico_asignado.last_name
              }
            a las ${moment(resp.data.fecha_hora).format('DD/MM/YYYY HH:mm')}`,
              {
                variant: 'success',
              }
            )
            this.$emit('changed')
          } else {
            this.$bvToast.toast(`Error al entregar el equipo: ${resp.data}`, {
              variant: 'danger',
            })
          }
        })
      } catch (error) {
        console.error('Error al entregar equipo a técnico:', error)
        this.$bvToast.toast('Error al entregar equipo a técnico', {
          variant: 'danger',
        })
      }
    },
  },
  computed: {
    ...mapGetters('AuthenticationStore', ['user']),
  },
}
</script>
